export default "__VITE_ASSET__CYPqzQQ8__ 400w, __VITE_ASSET__LH6d2Zzo__ 800w, __VITE_ASSET__Bs$Reucp__ 1200w";